var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-nav"},[_c('ul',{staticClass:"nav-list"},_vm._l((_vm.list),function(item,i){return _c('li',{key:i,class:{active:_vm.active==item.id},on:{"click":function($event){return _vm.jumpPage(item.url,item.id!=3)}}},[_c('i',{staticClass:"icon",class:'icon'+item.id}),_c('div',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }